<template>
  <div v-loading="loading" class="my-evaluatees">
    <div>
      <search-input
        placeholder="Поиск по ФИО"
        style="width: 300px"
        v-model="filters.search"
        @change="filtersChanged"
      >
      </search-input>
      <eval-evaluator-status-select
        v-model="filters.statuses"
        @change="filtersChanged"
      ></eval-evaluator-status-select>
      <eval-evaluator-type-select
        v-model="filters.types"
        @change="filtersChanged"
      ></eval-evaluator-type-select>
    </div>
    <div class="addition_evaluatees-block">
      <el-table :data="evaluatees" border>
        <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
        <el-table-column prop="user.email" label="Email"></el-table-column>
        <el-table-column width="300" prop="type_label" label="Тип оценивающего"></el-table-column>
        <el-table-column v-if="evaluation.setting && evaluation.setting.show_evaluator_answers" width="300" align="center" label="Результат">
          <template v-slot="scope">
            <el-button
              v-if="scope.row.status === 'evaluated'"
              size="mini"
              icon="fas fa-list-alt"
              @click="evaluate(scope.row)"
            >
              Смотреть
            </el-button>
            <p v-else>Нет оценки</p>
          </template>
        </el-table-column>
        <el-table-column width="320" label="Статус">
          <template v-slot="scope">
            <span class="status" :class="scope.row.status === 'evaluated' ? 'done' : 'in_progress'">{{ scope.row.status_label }}</span>
          </template>
        </el-table-column>
        <el-table-column width="120" label="Напоминание" v-if="evaluation.status !== 'finished'">
          <template v-slot="scope">
            <eval-remind-button :data="scope.row" :evaluation="evaluation"></eval-remind-button>
          </template>
        </el-table-column>
      </el-table>
      <paginator
        :paginator.sync="paginator"
        use-router-query-param
        @page-changed="loadEvaluatees"
      ></paginator>
    </div>

    <evaluate-evaluatee-dialog
      ref="evaluateDialog"
    >
    </evaluate-evaluatee-dialog>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import {mapGetters} from "vuex";
import EvalEvaluatorStatusSelect from "@/modules/evaluation/components/EvalEvaluatorStatusSelect.vue";
import EvalEvaluatorTypeSelect from "@/modules/evaluation/components/EvalEvaluatorTypeSelect.vue";
import EvaluateEvaluateeDialog from "@/modules/evaluation/components/myEvaluation/EvaluateEvaluateeDialog.vue";
import EvalRemindButton from "@/modules/evaluation/components/EvalRemindButton.vue";

export default {
  name: "my-evaluatees",
  components: {
    EvaluateEvaluateeDialog,
    EvalEvaluatorStatusSelect,
    EvalEvaluatorTypeSelect,
    SearchInput,
    EvalRemindButton,
    Paginator
  },
  data() {
    return {
      loading: false,
      evaluatees: [],
      filters: {},
    }
  },
  props: {
    evaluation: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [paginator],
  mounted() {
    this.loadEvaluatees();
  },
  computed:{
    ...mapGetters(['user'])
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  methods: {
    loadEvaluatees() {
      this.loading = true;
      this.$api.evaluation.evaluatorsSearch({
        ...this.filters,
        expand: ['user'].join(),
        evaluation_id: this.$route.params.id,
        evaluatee_id: this.user.id,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.evaluatees = data.evaluators;
          this.paginatorFill(paginator);

          this.$emit("update-total-count", data.allEvaluatorsInfo);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    evaluate(evaluatee) {
      this.$refs.evaluateDialog.open(evaluatee, this.evaluation);
    },
    filtersChanged() {
      this.loadEvaluatees();
    },
  }
}
</script>

<style scoped lang="scss">
  .my-evaluatees {
    .addition_evaluatees-block {
      margin: 25px 0;
    }

    .status {
      color: white;
      margin: 5px;
      border-radius: 10px;
      padding: 5px 10px;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: bold;
    }

    .status.done {
      background-color: #64d074;
    }

    .status.in_progress {
      background-color: #f3ae7b;
    }
  }
</style>